// Single source of truth for store info. Update this file to change address,
// phone, hours, or the free-delivery policy across the entire site.
//
// Do NOT hard-code address/phone/hours anywhere else — import from here.

export const STORE_NAME = "IPVALUE Marketplace";
export const STORE_LEGAL = "IPVALUE MARKETPLACE LLC";
export const STORE_PARENT = "IPVALUE MANAGEMENTS GROUP LLC";

export const STORE_ADDRESS = {
  street: "88 54th St SW, Suite 103",
  city: "Grand Rapids",
  state: "MI",
  postal: "49548",
  // Canonical string — use this IDENTICAL string everywhere. Always "Suite 103".
  short: "88 54th St SW, Suite 103, Grand Rapids, MI 49548",
  // For SEO / schema
  full: "88 54th St SW, Suite 103, Grand Rapids, MI 49548",
};

export const SERVICE_AREA_SHORT = "Grand Rapids, MI";
export const SERVICE_AREA_LONG = "Grand Rapids and West Michigan";
export const SERVING_TAGLINE = "Serving Grand Rapids and West Michigan from our Grand Rapids showroom";
// Google Maps directions URL — opens turn-by-turn in the user's map app.
export const STORE_GMAPS_DIRECTIONS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=88%2054th%20St%20SW%20Suite%20103%2C%20Grand%20Rapids%2C%20MI%2049548";

export const STORE_PHONE = "616-410-0158";
export const STORE_PHONE_TEL = "+16164100158";

// Owner's Google Business Profile review link — used everywhere we ask for a review.
export const GOOGLE_REVIEW_URL = "https://g.page/r/CQjY25oZilEuEBE/review";

export const STORE_HOURS = {
  // In shape schema.org expects
  schema: [
    "Mo-Sa 10:00-19:00",
    "Su 12:00-17:00",
  ],
  // In shape humans expect
  display: "Mon–Sat 10:00 AM – 7:00 PM · Sun 12:00 PM – 5:00 PM",
  displayLines: [
    { days: "Mon – Sat", hours: "10:00 AM – 7:00 PM" },
    { days: "Sunday", hours: "12:00 PM – 5:00 PM" },
  ],
};

// Delivery policy — DO NOT re-word without updating the policy page in lockstep.
export const DELIVERY = {
  freeThreshold: 299,
  freeRadiusMiles: 10,
  banner: "FREE delivery on orders $299+ within 10 miles",
  shortLine: "$0 free within 10mi on $299+ orders · $39 under $299 · $49 for 10–25mi · +$2/mi beyond",
  scheduleDays: "Deliveries run Tuesday · Thursday · Saturday.",
  cutoff: "Orders paid by 2 PM go on the next delivery day.",
  eta: "Most orders arrive in 2 to 4 days.",
  saturdayNote: "Saturday deliveries run 9 AM – 1 PM.",
};

// Pallet policy — used on the Pallets policy page + department-policy block.
export const PALLET = {
  deliveryFlat10mi: 75,
  deliveryFlat25mi: 99,
  guarantee: [
    "Store credit for items that are broken, non-functional, or missing major parts",
    "Up to 15% of the items on the manifest",
    "Credit per item = pallet price divided by manifest item count",
    "Claim within 48 hours of pickup or delivery, with a photo of each item",
    "One claim per pallet, all items at once. Store credit only, valid 90 days",
  ],
  guaranteeExclusions: [
    "Dirty, dusty, scratched, or worn items",
    "Opened boxes or missing packaging",
    "Outdated models",
    "Items the buyer could not resell",
    "Anything marked EXCLUDED FROM GUARANTEE on the manifest",
    "Anything reported after 48 hours or without a photo",
  ],
};
